/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import React from "react";
import { colors } from "./colors";

const dividerStyle = css`
  width: 6px;
  min-width: 6px;
  height: 6px;
  min-height: 6px;
  border-radius: 9999px;
  background-color: ${colors.greyBorder};
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  additionalStyles?: SerializedStyles;
}

export const DotDivider = ({ additionalStyles, ...rest }: Props) => {
  return <div css={[dividerStyle, additionalStyles]} {...rest} />;
};
